<template>
  <div class="mainpage">
      <div title="Sign Out" class="click r" @click="logout"><b>Logout</b></div>
      <h1 @click="test">Welcome!</h1>
      <ul class="mainmenu">
          <li><router-link to="/serials">Serial Numbers Management</router-link></li>
          <li><router-link to="/produced">New Manufacturing</router-link></li>
          <li><router-link to="/shipped">New Shipment</router-link></li>
          <li><router-link to="/deliverynote">Print Serial Numbers Attachment</router-link></li>
          <!--<li><router-link to="/transfers">Transfers</router-link></li>-->
          <li><router-link to="/inventory">Inventory Count</router-link> (<router-link to="/inventory-admin">Management</router-link>)</li>
      </ul>
      <div class="version">v20.2.5</div>
  </div>
</template>


<script>
    export default {
        name: 'home',
        data(){
            return {
            };
        },
        methods: {
            logout: function () {
                this.$store.commit('logout');
                this.$router.push('/login');
            },
            test() {
                this.$store.dispatch('testcall');
            }
        }
    };
</script>

<style scoped>
    .r { text-align:  right}
    .mainpage {
        padding-top: 5px;
        max-width: 900px;
        margin: 0 auto ;
    }

    .home {
        margin: 10px auto 0 auto ;
        padding: 0 20px;
        max-width: 900px;
        position: relative;
        border: solid 1px #ccc;
        border-radius: 5px;
    }
    LI { padding: 15px;
        font-size: 18px; }
    .mainmenu A { border-bottom: solid 1px #666 }
    .version { font-size: 80%; text-align:right; color: #999 }
</style>